<template>
    <div class="conversion-history-section">
        <draggable
            :modelValue="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
            item-key="timestamp"
            class="conversion-history"
            animation="200"
        >
            <template #item="{ element, index }">
                <div class="history-item">
                    <div class="thumb-index">{{ index + 1 }}</div>
                    <img :src="element.thumbnail" />

                    <div class="history-overlay">
                        <button
                            @click.stop="$emit('delete', index)"
                            class="delete-thumb"
                        >
                            ×
                        </button>

                        <div
                            v-if="element.processing"
                            class="processing-indicator"
                        >
                            ⏳
                        </div>
                        <div v-else class="converted-indicator">
                            ✓
                        </div>
                    </div>
                </div>
            </template>
        </draggable>
    </div>
</template>

<script setup>
import draggable from 'vuedraggable';

defineProps({
    modelValue: {
        type: Array,
        default: () => []
    }
});

defineEmits(['update:modelValue', 'delete']);
</script>

<style scoped>
.conversion-history-section {
    margin-top: 8px;
    margin-bottom: 8px;
}

.conversion-history {
    display: flex;
    gap: 8px;
    padding: 12px;
    background: rgba(19, 19, 19, 0.4);
    border: 2px solid var(--accent);
    overflow-x: auto;
}

.history-item {
    position: relative;
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    cursor: pointer;
    border: 2px solid var(--accent);
    transition: all 0.2s;
    overflow: hidden;
}

.history-item:hover {
    border-color: var(--accent);
    transform: scale(1.05);
}

.history-item img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
}

.history-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.delete-thumb {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 20px;
    height: 20px;
    background: rgba(244, 67, 54, 0.9);
    color: white;
    border: none;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    padding: 0;
}

.delete-thumb:hover {
    background: #f44336;
}

.processing-indicator,
.converted-indicator {
    font-size: 24px;
    pointer-events: none;
}

.thumb-index {
    position: absolute;
    top: 4px;
    left: 4px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 2px 6px;
    font-size: 12px;
    border-radius: 4px;
    z-index: 5;
    pointer-events: none;
}
</style>